/**
 * Whether the CD-ROM "Data Request" prompt (DataRequestDialog) is on screen.
 *
 * The prompt and the progress overlays (HistoricalProgressDialog,
 * DownloadProgressDialog) are all flex-centred cards on the same overlay
 * z-index, and App.tsx mounts the progress dialogs after the prompt — so an
 * in-flight build/download card would paint over the prompt and make
 * Skip / Browse / Download / Cancel unclickable. Progress dialogs subscribe
 * here and hide while the user is being asked, reappearing once an option is
 * chosen. Same-window on both desktop and web (the prompt only ever shows in
 * the main window), so a module-level signal is enough.
 */

type Subscriber = (open: boolean) => void;

let promptOpen = false;
const subscribers = new Set<Subscriber>();

/** Called by DataRequestDialog as the prompt opens/closes. */
export function setCdromPromptOpen(open: boolean): void {
  if (promptOpen === open) return;
  promptOpen = open;
  subscribers.forEach((cb) => cb(open));
}

export function isCdromPromptOpen(): boolean {
  return promptOpen;
}

/** Subscribe to prompt open/close; fires immediately with the current state. */
export function subscribeCdromPrompt(cb: Subscriber): () => void {
  subscribers.add(cb);
  cb(promptOpen);
  return () => {
    subscribers.delete(cb);
  };
}
